'use strict';

var classChecks = require('../../common/var/classChecks');

var isString = classChecks.isString;

function getRangeMemberNumericValue(m) {
  return isString(m) ? m.charCodeAt(0) : m;
}

module.exports = getRangeMemberNumericValue;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/range/internal/getRangeMemberNumericValue.js
// module id = 857
// module chunks = 0